// Where the overlay is in each relay channel's stream, so a reconnect gets
// exactly what it missed. The relay stamps every frame with
// `rx: "<relay start>|<channel>|<counter>"`; the page keeps the last one per
// channel and sends them back on reconnect (`since`), and the relay replays the
// frames after them: none twice, none missed, whatever the clocks say. A relay
// that restarted (a different start) replays everything it kept.

/** The longest cursor taken from a frame (the relay checks them again). */
const MAX_CURSOR = 200;

/** Keep the frame's cursor, if it has one. */
export function noteFrame(cursors: Map<string, string>, frame: unknown): void {
  const rx = (frame as { rx?: unknown } | null)?.rx;
  if (typeof rx !== 'string' || rx.length > MAX_CURSOR) return;
  const parts = rx.split('|');
  if (parts.length !== 3 || !parts[1] || !/^\d+$/.test(parts[2])) return;
  cursors.set(parts[1], rx);
}

/** The `since` query part for a reconnect, or '' when nothing was received. */
export function sinceParam(cursors: Map<string, string>): string {
  if (cursors.size === 0) return '';
  return `&since=${encodeURIComponent([...cursors.values()].join(','))}`;
}
